import { computed, toValue } from "vue";
import { useComponentGraphStoreV2 } from "..";
export const useComponentTree = (componentId) => {
    const componentGraphStore = useComponentGraphStoreV2();
    return computed(() => {
        const componentIdValue = toValue(componentId);
        if (!componentIdValue) {
            return undefined;
        }
        return componentGraphStore.getComponentTree(componentIdValue);
    });
};
